import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Form, Feed, Divider, Menu, Grid } from 'semantic-ui-react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import * as UiConsts from '../../../../config/UiConstants';
import { pythonApiIp, getOrderKey } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import { algoliaPartialUpdateOrder } from '../algoliaDashboard/AlgoliaMiscUtils';

class InHouseStockItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }


    markInHouseItem = (item, inhouse_id, order_num) => {
        console.log("++++: markInHouseItem");
        console.log("item:" + item);
        console.log("inhouse_id:" + inhouse_id);
        console.log("order_num:" + order_num);

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            inhouseItem_flag: true,
            inhouseItem: item,
            inhouseItem_by: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        axios.post(pythonApiIp + 'addInhouseItemToOrder', {
            apiKey: "InHouseStockItem",
            inhouse_name: item,
            inhouse_id: inhouse_id,
            order_num: order_num,
            enteredBy: this.props.user.email,
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("upwhn12 reply:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("upwhn13 result is true:");

                    alert(response.data.message);

                } else {
                    alert("Failed to update number")
                }

            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    mark_jumper = (item) => {
        console.log("++++: mark_jumper");
        console.log("item:" + item);

        //item, inhouse_id, order_num
        this.markInHouseItem('jumper_china', 343, this.props.order.order_num);
    }

    mark_jumper_zipper = (item) => {
        console.log("++++: mark_jumper_zipper");
        console.log("item:" + item);

        //item, inhouse_id, order_num
        this.markInHouseItem('jumper_zipper', 442, this.props.order.order_num);
    }

    mark_t_shirt = (item) => {
        console.log("++++: mark_t_shirt");
        console.log("item:" + item);

        this.markInHouseItem('t-shirts_in_house', 437, this.props.order.order_num);
    }

    mark_t_shirt_v_neck = (item) => {
        console.log("++++: mark_t_shirt");
        console.log("item:" + item);

        this.markInHouseItem('t-shirts_in_house_v_neck', 441, this.props.order.order_num);
    }


    render() {

        const jumperUI = this.props.order.itemType === 'jumper' && !this.props.searchNow
            ? <Button color='teal' onClick={this.mark_jumper}>Mark Jumper</Button>
            : ''

        const jumper_zipper_UI = this.props.order.itemType === 'jumper' && !this.props.searchNow
            ? <Button color='teal' onClick={this.mark_jumper_zipper}>Jumper - Zipper</Button>
            : ''

        const t_shirt_ui = this.props.order.itemType === 't-shirts' && !this.props.searchNow
            ? <Button color='brown' onClick={this.mark_t_shirt}>Mark T-shirt</Button>
            : ''

        const t_shirt_ui_v_neck = this.props.order.itemType === 't-shirts' && !this.props.searchNow
            ? <Button color='brown' onClick={this.mark_t_shirt_v_neck}>Mark V-Neck T-shirt</Button>
            : ''

        const show_ui = this.props.order.inhouseItem_flag
            ? <h4>Inhouse item:{this.props.order.inhouseItem}</h4>
            : <h4>Inhouse item: NONE</h4>

            
        const wholeUi = this.props.algoliaUser
            && this.props.algoliaUser.perms
            && this.props.algoliaUser.perms.includes("mark_inHouseStockItem")
            && (this.props.order.itemType === 't-shirts' || this.props.order.itemType === 'jumper')
            ? <div>
                <Divider horizontal>{'IN HOUSE STOCK ITEM'}</Divider>
                {show_ui}
                {t_shirt_ui}
                {t_shirt_ui_v_neck}
                {jumperUI}
                {jumper_zipper_UI}

            </div>
            : ''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            {wholeUi}

        </div>);
    }
}

export default InHouseStockItem;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/InHouseStockItems/InHouseStockItem.js